import { styled } from "@stitches/react";
import { useState } from "react";
import { Button } from "@/vendor/Forge/dist";

const Wrapper = styled("div", {
  display: "flex",
  justifyContent: "left",
  alignItems: "center",
  width: "fit-content",
  font: "18px",

  "& ul": {
    display: "flex",
    flexDirection: "column",
    whiteSpace: "nowrap",
    marginBottom: "0px",
  },
});

const ShowHideWrapper = styled("div", {
  display: "flex",
  flexDirection: "column",

  "& .fe_c_button__content": {
    display: "flex",
    justifyContent: "left",
  },
});

interface Props {
  taoFieldData: string[];
}

const TaoField = ({ taoFieldData }: Props) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <Wrapper>
      {taoFieldData.length > 5 && showAll == false ? (
        <ShowHideWrapper>
          <ul>
            {taoFieldData.slice(0, 5).map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <Button
            data-testid="see-more-button"
            onClick={() => setShowAll(true)}
            variant="tertiary"
          >
            See More
          </Button>
        </ShowHideWrapper>
      ) : taoFieldData.length > 5 && showAll == true ? (
        <ShowHideWrapper>
          <ul>
            {taoFieldData.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <Button
            data-testid="see-less-button"
            onClick={() => setShowAll(false)}
            variant="tertiary"
          >
            See Less
          </Button>
        </ShowHideWrapper>
      ) : taoFieldData.length == 1 ? (
        taoFieldData
      ) : (
        <ShowHideWrapper>
          <ul>
            {taoFieldData.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </ShowHideWrapper>
      )}
    </Wrapper>
  );
};

export default TaoField;
